import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const headerContainer = css`
    display: flex;
    flex-wrap: wrap;
    gap: ${Spacing.MD}px;
    align-items: center;
    justify-content: space-between;
`;

export const contentContainer = css`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
`;

export const buttonContainer = css`
    flex-shrink: 0;
`;

export const folderName = css`
    max-width: clamp(200px, 50vw, 600px);
`;

export const manageMembersButton = css`
    white-space: nowrap;
`;
